import Layout from 'Nori/Layout';
import Hero from 'Custom/Hero';
import RichText from 'Custom/RichText';
import styles from 'styles/pages/whatToExpect.module.scss';
import Button from 'Nori/Button';
import QuestionWrapper from 'Custom/Question/QuestionsWrapper';
import Question from 'Custom/Question/index';
import Container from 'Nori/Container';
import { AlternativeTable } from 'Custom/Table/AlternativeTable';
import { SE_TABLE_3 } from 'Utils/side-effects';
import BrandFooter from 'Custom/Footer/BrandFooter';

import HERO_WTE_IMAGE from 'Images/people/veronica-what-to-expect-hero.webp';
import HERO_WTE_IMAGE_MOBILE from 'Images/people/veronica-what-to-expect-hero-mobile.webp';
import DownloadIcon from 'Images/brand-icons/download-file.svg';
import { WHAT_TO_EXPECT_UPDATES_JOBCODE } from 'Custom/Footer/Footer.utils.js';

import {
  FAQ_WTE_INSERTION_1,
  WTE_PERIOD,
  WTE_SIDE_EFFECTS,
  CALL_HCP_QUESTION,
} from 'Utils/what-to-expect';

const HEAD = {
  title:
    'What to Expect With NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Learn about what to expect after insertion of NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, including common side effects and when to call your doctor.',
  keywords: 'what to expect after nexplanon insertion',
};

const HERO_IMAGE = {
  src: HERO_WTE_IMAGE,
  fill: true,
  objectFit: 'cover',
  objectPosition: '50% top',
};

const HERO_MOBILE_IMAGE = {
  src: HERO_WTE_IMAGE_MOBILE,
  fill: true,
  objectFit: 'cover',
  objectPosition: 'top center',
};

export default function WhatToExpect() {
  return (
    <Layout
      head={HEAD}
      jobCode={WHAT_TO_EXPECT_UPDATES_JOBCODE}
      hideBrandFooter
    >
      <Hero
        title={
          <>
            <strong>WHAT TO EXPECT</strong>
          </>
        }
        autoHeightOnMobile
        caption="actor portrayals"
        image={HERO_IMAGE}
        mobileImage={HERO_MOBILE_IMAGE}
        imageBreakpoint="md"
        className={styles.hero}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Hero"
        data-design-module_name="what to expect"
        data-design-module_no="01"
      >
        <RichText>
          <h2>what to expect after your insertion procedure</h2>
        </RichText>
        <Button
          href="/assets/static/What-to-Expect-Guide-Refreshed-2025.pdf"
          target="_blank"
          rel="noopener"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Download"
          data-design-label="Download Aftercare Brochure"
          data-design-nori_id="Hero"
          data-design-module_name="what to expect"
          data-design-module_no="01"
        >
          Download Aftercare Brochure
          <DownloadIcon />
        </Button>
      </Hero>
      <section className={styles.accordionContainer}>
        <QuestionWrapper
          title={'what to expect after insertion'}
          question={FAQ_WTE_INSERTION_1}
          content={null}
          moduleNumber="02"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="what to expect after insertion"
        />

        <QuestionWrapper
          title={'will it affect my period?'}
          background="blue"
          content={WTE_PERIOD[0].content}
          moduleNumber="03"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="will it affect my period?"
        />

        <QuestionWrapper
          title={'what other side effects could I experience?'}
          question={WTE_SIDE_EFFECTS}
          size="large"
          titSize="large"
          content={null}
          moduleNumber="04"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-module_name="what other side effects could I experience?"
        />
      </section>
      <div
        className={styles.tableBg}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="when should I call my healthcare professional?"
        data-design-module_no="05"
      >
        <Container>
          <RichText className={styles.tableWrapper}>
            <div className={styles.title}>
              <h2>when should I call my healthcare professional?</h2>
              <h3>
                call your healthcare professional immediately if you have…
              </h3>
            </div>
            <AlternativeTable
              content={SE_TABLE_3}
              size="sm"
              title="call your doctor immediately if you have …"
            />
          </RichText>

          <Question question={CALL_HCP_QUESTION} direction="row" size="large" />
        </Container>
      </div>
      <BrandFooter />
    </Layout>
  );
}
